import React, { useState, useEffect, useContext } from 'react'
import moment from 'moment'
import _, {
 filter as filterLodash, isNaN, isNil, isNull,
} from 'lodash'
import numeral from 'numeral'
import { Mutation } from 'react-apollo'
import FileDownload from 'js-file-download'
import axios from 'axios'
import { useLazyQuery, useMutation, useQuery } from '@apollo/react-hooks'
import { Link } from 'react-router-dom'
import {
  message, Menu, DatePicker, TimePicker, Select, Modal, Checkbox, Button, Dropdown, Icon, Row, Col, Upload,
  AutoComplete,
} from 'antd'
import {
  SmallText, Div, Button as KonsysButton, InputWithLabel, Input, P as KonsysP, Loading, Icon as KSIcon,
} from 'konsys-ui'
import { TriangleAlert } from 'lucide-react'
import history from '../../history'
import { theme } from '../../styles/_variables'
import {
 SHIPPING_ORDER, GET_SHIPPING_ORDER_QR_CODE, GET_JOB, JOB_LIST, JOB_SEARCH,
} from '../../constants/graphql/query'
import {
  fuelStatus, fuelStatusText, unitVar, unitText, unitValue, status,
} from '../../pages/shipping-order-page/constants'
import { P } from '../../pages/shipping-order-page/styled'
import { LoadingPage } from '../common'
import {
  DUPLICATE_SHIPPING_ORDER, CANCEL_SHIPPING_ORDER, ASSIGN_DELIVERED, DRIVER_PICKED_UP, DRIVER_DELIVERED,
  MOVE_SHIPPING_ORDER,
} from '../../constants/graphql/mutation'
import PERMISSION from '../../constants/permissions'
import { getAccessToken, getURL } from '../../utils/local-data-service'
import { checkNotNumber, checkInt, checkFloat } from '../../utils/util-services'
import COMPANY_NAME from '../../constants/company-name'
import pdr from '../../assets/pdr.png'
import { logoSelector } from '../../pages/shipping-order-page/util-functions'

const { color } = theme

export const CellText = props => (
  <P font='sarabun' padding='3px' {...props}>{props.children}</P>
)

export const mappingValueToText = (value) => {
  switch (value) {
    case unitValue.TON: return unitText.TON
    case unitValue.KG: return unitText.KG
    case unitValue.H50: return unitText.H50
    case unitValue.H60: return unitText.H60
    case unitValue.H100: return unitText.H100
    case unitValue.TRIP: return unitText.TRIP
    default: return 'เลือกหน่วย'
  }
}

export const HeaderLabel = props => (
  <SmallText bold color={color.coolGrey} font='sarabun' style={{ fontWeight: 700 }}>{props.children}</SmallText>
)

export const InputWithPlaceHolder = ({ handleChange }) => (
  <input placeholder='ค้นหา' onChange={e => handleChange(e.target.value)} />
)

const isLatedMoreThan15days = (shippingStatus, assignDate) => shippingStatus === status.EXPIRED && moment(assignDate).diff(moment(), 'd') < -15

const menu = (
  props,
  onDuplicateModalChange,
  handleDeliveryModal,
  refetch,
  isDriver = false,
  setCancelModal,
  setChangeJobModal,
) => (
  <Div>
    <Menu selectedKeys={undefined}>
      <Menu.Item key='view' disabled={!_.includes(window.perms, PERMISSION.VIEW_SHIPPING_ORDER)}>
        <Link target="_blank" to={`/shipping-order/view/${props.original.id}`}>
          ดูรายละเอียด
        </Link>
      </Menu.Item>
      <Menu.Item
        key='edit'
        disabled={!_.includes(window.perms, PERMISSION.UPDATE_SHIPPING_ORDER) || !_.includes([status.WAITING, status.ASSIGNED, status.EXPIRED, status.CANCELLED, status.PICKEDUP, status.DELIVERED], props.original.status) || isLatedMoreThan15days(props.original.status, props.original.assignDate)}
      >
        <Link
          to={{
            pathname: `/shipping-order/edit/${props.original.id}`,
            state: { onlyStartEndDestination: _.includes([status.PICKEDUP, status.DELIVERED], props.original.status) },
          }}
        >
          แก้ไข
        </Link>
      </Menu.Item>
      <Menu.Item key='duplicate' onClick={() => onDuplicateModalChange(true)} disabled={!_.includes(window.perms, PERMISSION.CREATE_SHIPPING_ORDER)}>
        สร้างซ้ำ
      </Menu.Item>
      <Menu.Item
        key='driver'
        disabled={!_.includes(window.perms, PERMISSION.ASSIGN_SHIPPING_ORDER) || !_.includes([status.ASSIGNED, status.WAITING], props.original.status)}>
        <Link
          to={{
            pathname: `/shipping-order/edit/${props.original.id}`,
            state: { accessDriver: true },
          }}
        >
          {_.includes([status.ASSIGNED], props.original.status) ? 'แก้ไขข้อมูลจ่ายงาน' : 'จ่ายงาน'}
        </Link>
      </Menu.Item>
      <Menu.Item
        key='change-job'
        disabled={_.includes([status.CANCELLED], props.original.status)}
        onClick={() => setChangeJobModal(true)}
      >
        ย้ายสัญญางาน
      </Menu.Item>
      <Menu.Item
        key='fuel'
        disabled={!_.isNull(props.original.FuelOrder.id)
          || !_.includes(window.perms, PERMISSION.CREATE_FUEL)
          || !_.includes([status.ASSIGNED, status.DELIVERED, status.BILLED], props.original.status)
        }>
        <Link
          to={{
            pathname: `/shipping-order/edit/${props.original.id}`,
            state: { accessFuel: true },
          }}
        >
          สร้างใบเบิกน้ำมัน
        </Link>
      </Menu.Item>
      <Menu.Item
        key='specialFuel'
        disabled={
          !_.isNil(props.original.FuelOrders?.find(fo => fo.isSpecial)?.id)
          || !_.includes(window.perms, PERMISSION.CREATE_FUEL)
          || _.includes([status.WAITING], props.original.status)
        }
      >
        <Link
          to={{
            pathname: `/shipping-order/edit/${props.original.id}`,
            state: { accessSpecialFuel: true },
          }}
        >
          สร้างใบเบิกน้ำมันพิเศษ
        </Link>
      </Menu.Item>
      {
        isDriver
          ? <Menu.Item
            key='record'
            disabled={
              !_.includes(window.perms, PERMISSION.RECORD_DELIVERY_SHIPPING_ORDER)
              || !_.includes([status.ASSIGNED, status.PICKEDUP, status.DELIVERED, status.EXPIRED, status.BILLED], props.original.status)
              || isLatedMoreThan15days(props.original.status, props.original.assignDate)
              || (props.original.status === status.EXPIRED && _.isNull(props.original.Truck.plateNumber))
            }
            onClick={() => handleDeliveryModal()}
          >
            {_.includes([status.ASSIGNED, status.PICKEDUP, status.EXPIRED], props.original.status)
              ? 'บันทึกการขนส่ง'
              : 'แก้ไขการขนส่ง'
            }
          </Menu.Item>
          : <Menu.Item
            key='record'
            disabled={
              !_.includes(window.perms, PERMISSION.RECORD_DELIVERY_SHIPPING_ORDER)
              || !_.includes([status.ASSIGNED, status.PICKEDUP, status.DELIVERED, status.EXPIRED, status.BILLED], props.original.status)
              || isLatedMoreThan15days(props.original.status, props.original.assignDate)
              || (props.original.status === status.EXPIRED && _.isNull(props.original.Truck.plateNumber))
            }
          >
            <Link
              to={{
                pathname: `/shipping-order/edit/${props.original.id}`,
                state: { accessDelivered: true },
              }}
            >
              {_.includes([status.ASSIGNED, status.PICKEDUP, status.EXPIRED], props.original.status)
                ? 'บันทึกการขนส่ง'
                : 'แก้ไขการขนส่ง'
              }
            </Link>
          </Menu.Item>
      }
      <Menu.Item
        key='cancel'
        onClick={() => setCancelModal(true)}
        disabled={!_.includes(window.perms, PERMISSION.UPDATE_SHIPPING_ORDER) || !_.includes([status.WAITING, status.ASSIGNED, status.EXPIRED, status.PICKEDUP], props.original.status)}
      >
          ยกเลิก
      </Menu.Item>
      <Menu.Item
        key='history'
        disabled={!_.includes(window.perms, PERMISSION.VIEW_SHIPPING_ORDER)}
      >
        <Link
          target="_blank"
          to={{
            pathname: `/shipping-order/history/${props.original.id}`,
          }}
        >
          ประวัติการแก้ไข
        </Link>
      </Menu.Item>
    </Menu>
  </Div>
)

export const RemarkRenderer = (props) => {
  const msg = props?.data?.split('@').map((v) => {
    if (_.indexOf(v, '/') > 0 && _.indexOf(v.split('/').map(number => !_.isNaN(parseInt(number, 10))), false) < 0) return <a href={`${getURL().WEB_SERVER}/shipping-order/view/${v}`} target='_blank' rel="noopener noreferrer">{v}</a>
    return (v)
  })
  return (
    <Div>
      <P display='block' margin='0 0 32px'>{msg}</P>
    </Div>
  )
}

export const TypeSelector = ({
  handleChange, filter, disabled,
}) => {
  const arr = [
    { value: fuelStatus.CLIENT, text: fuelStatusText.CLIENT },
    { value: fuelStatus.SUPPLIER, text: fuelStatusText.SUPPLIER },
  ]

  const filterer = filter ? _.concat({ value: 'ALL', text: 'ทั้งหมด' }, arr) : arr

  return (
    <Select
      disabled={disabled}
      dropdown
      defaultValue="ทั้งหมด"
      onChange={e => handleChange(e)}
    >
      {
        filterer.map(v => <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>)
      }
    </Select>
  )
}

export const DropdownSelector = ({
  data, handleChange, typeNameTh, width: w, value, moreProps,
}) => {
  const width = typeNameTh ? '120px' : w || '100px'
  return (
    <Select
      value={value}
      defaultValue='ทั้งหมด'
      dropdown
      maxHeight='none'
      style={{ width }}
      onChange={e => (e === 'ALL' ? handleChange('') : handleChange(e))}
      {...moreProps}
    >
      {
        data.map(v => <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>)
      }
    </Select>
  )
}

export const ActionSelector = ({
 props, refetch, availableOrder, shippingsAmount,
}) => {
  const [duplicateModal, setDuplicateModal] = useState(false)
  const [cancelModal, setCancelModal] = useState(false)
  const [changeJobModal, setChangeJobModal] = useState(false)

  return (
    <Div>
      <Dropdown
        overlay={
          menu(
            props,
            setDuplicateModal,
            () => message.error('เกิดข้อผิดพลาด'),
            refetch,
            false,
            setCancelModal,
            setChangeJobModal,
          )
        }
        trigger='click'
      >
        <Button>
          ดูรายละเอียด <Icon type="down" />
        </Button>
      </Dropdown>
      <DuplicateModal
        id={props.original.id}
        modal={duplicateModal}
        setModal={setDuplicateModal}
        refetch={refetch}
        fuelId={props.original.FuelOrder.id}
        driverId={props.original.Driver.id}
        availableOrder={availableOrder}
        shippingsAmount={shippingsAmount}
      />
      <CancelModal
        shippingId={props.original.id}
        visible={cancelModal}
        setVisible={setCancelModal}
        refetch={refetch}
        fuelOrders={props.original.FuelOrders}
      />
      <ChangeJobModal
        shippingId={props.original.id}
        jobId={props.original.Job.id}
        visible={changeJobModal}
        setVisible={setChangeJobModal}
        refetch={refetch}
      />
    </Div>
  )
}

export const DriverActionSelector = ({ props, refetch }) => {
  const [deliveryModal, setDeliveryModal] = useState(false)
  const [isDataLoaded, setIsDataLoaded] = useState(false)
  const [getShipping, {
    loading: shippingDetailLoading, data: shippingDetailData,
  }] = useLazyQuery(SHIPPING_ORDER)
  const handleDeliveryModal = () => {
    setDeliveryModal(true)
    getShipping({ variables: { id: `${props.original.id}` } })
    setIsDataLoaded(true)
  }
  return (
    <Div>
      <Dropdown overlay={menu(props, () => message.error('เกิดข้อผิดพลาด'), handleDeliveryModal, refetch, true)} trigger='click'>
        <Button>
          ดูรายละเอียด <Icon type="down" />
        </Button>
      </Dropdown>
      <DeliveryModal shippingDetailData={shippingDetailData} shippingDetailLoading={shippingDetailLoading} deliveryModal={deliveryModal} setDeliveryModal={setDeliveryModal} refetch={refetch} isDataLoaded={isDataLoaded} />
    </Div>
  )
}

export const SuperReportModal = ({
  modal,
  setModal,
}) => {
  const [range, setRange] = useState([])
  const [loading, setIsLoading] = useState(false)
  const [dateType, setDateType] = useState('createdAt')
  const limitList = [
    { value: 'createdAt', text: 'วันที่สร้างรายการ' },
    { value: 'deliveryDate', text: 'วันที่นำส่ง' },
  ]
  return (
    <Modal
      title='กรุณาเลือกวันเริ่มต้นและวันสิ้นสุด'
      visible={modal}
      onCancel={() => {
        setModal(false)
        setDateType('createdAt')
        setRange([])
      }}
      onOk={() => {
        setIsLoading(true)
        axios({
          method: 'GET',
          responseType: 'blob',
          headers: {
            Authorization: `Bearer ${getAccessToken()}`,
          },
          url: `${getURL().FILE_SERVER}/download/superuser/report/shippingorders?startDate=${moment(range[0]).format('YYYY-MM-DD')}&endDate=${moment(range[1]).format('YYYY-MM-DD')}&dateType=${dateType}`,
        }).then((resp) => {
          FileDownload(resp.data, `รายงานใบสั่งบรรทุก${_.find(limitList, e => e.value === dateType).text} ${moment(range[0]).format('YYYY-MM-DD')} - ${moment(range[1]).format('YYYY-MM-DD')} .xlsx`)
          setIsLoading(false)
          setModal(false)
          setDateType('createdAt')
          setRange([])
        })
      }}
      okButtonProps={{ disabled: _.isEmpty(range) || loading }}
    >
      <Div textAlign='center'>
        <Select
          autoClearSearchValue
          dropdown
          style={{ width: 150, margin: '0 0 24px 0' }}
          defaultValue="วันที่สร้างรายการ"
          onSelect={(e) => {
            setDateType(e)
          }}
        >
          {
            limitList.map(v => <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>)
          }
        </Select>
        <DatePicker.RangePicker
          format='DD/MM/YYYY'
          onChange={(e) => {
            setRange(e)
          }}
        />
      </Div>
    </Modal>
  )
}

export const DateFilterSelectors = ({
  filtered,
  setFiltered,
  dateType,
  setDateType,
  setCurrent,
}) => {
  const [modal, setModal] = useState(false)
  const [range, setRange] = useState([])
  const limitList = [
    { value: 'all', text: 'ทั้งหมด' },
    { value: 'createdDate', text: 'วันที่สร้างรายการ' },
    { value: 'assignDate', text: 'วันที่ครบกำหนด' },
    { value: 'deliveryDate', text: 'วันที่นำส่ง' },
    { value: 'recordDate', text: 'วันที่บันทึกการขนส่ง' },
  ]
  return (
    <Div>
      <Select
        autoClearSearchValue
        dropdown
        style={{ width: 150 }}
        defaultValue="ทั้งหมด"
        onSelect={(e) => {
          if (e === 'all') {
            setFiltered({
              ...filtered,
              startAssignDate: null,
              endAssignDate: null,
              startRecordDate: null,
              endRecordDate: null,
              startCreatedAt: null,
              endCreatedAt: null,
              startDeliveryDate: null,
              endDeliveryDate: null,
            })
          } else {
            setDateType(e)
            setModal(true)
          }
        }}
      >
        {
          limitList.map(v => <Select.Option key={v.value} value={v.value}>{v.text}</Select.Option>)
        }
      </Select>
      <Modal
        title='กรุณาเลือกวันเริ่มต้นและวันสิ้นสุด'
        visible={modal}
        onCancel={() => setModal(false)}
        onOk={() => {
          if (dateType === 'assignDate') {
            setFiltered({
              ...filtered,
              startAssignDate: range[0],
              endAssignDate: range[1],
              startRecordDate: null,
              endRecordDate: null,
              startCreatedAt: null,
              endCreatedAt: null,
              startDeliveryDate: null,
              endDeliveryDate: null,
            })
            setCurrent(0)
          } else if (dateType === 'createdDate') {
            setFiltered({
              ...filtered,
              startAssignDate: null,
              endAssignDate: null,
              startRecordDate: null,
              endRecordDate: null,
              startCreatedAt: range[0],
              endCreatedAt: range[1],
              startDeliveryDate: null,
              endDeliveryDate: null,
            })
            setCurrent(0)
          } else if (dateType === 'deliveryDate') {
            setFiltered({
              ...filtered,
              startAssignDate: null,
              endAssignDate: null,
              startRecordDate: null,
              endRecordDate: null,
              startCreatedAt: null,
              endCreatedAt: null,
              startDeliveryDate: range[0],
              endDeliveryDate: range[1],
            })
            setCurrent(0)
          } else {
            setFiltered({
              ...filtered,
              startAssignDate: null,
              endAssignDate: null,
              startRecordDate: range[0],
              endRecordDate: range[1],
              startCreatedAt: null,
              endCreatedAt: null,
              startDeliveryDate: null,
              endDeliveryDate: null,
            })
            setCurrent(0)
          }
          setModal(false)
        }}
        okButtonProps={{ disabled: _.isEmpty(range) }}
      >
        <Div textAlign='center'>
          <DatePicker.RangePicker
            format='DD/MM/YYYY'
            onChange={(e) => {
              setRange(e)
            }}
          />
        </Div>
      </Modal>
    </Div>
  )
}

export const Wrapper = props => (
  <Div
    display='block'
    width='100%'
    flexDirection='row'
    padding={props.padding || '40px 0'}
    justifyContent={props.center && 'center'}
    alignItems='flex-end'
    style={{ borderBottom: `1px solid ${color.paleGrey}`, overflow: props.overflow && 'auto' }}
  >
    {props.children}
  </Div>
)

export const ActionBar = ({
  loading,
  isAddMode,
  isViewMode,
  doAction,
  mutationVariables,
  props,
  disabledPrint,
  ShippingorderInfo,
  unit,
  jobInfo,
  creatingFuel,
  refetch,
}) => {
  const [changeJobModal, setChangeJobModal] = useState(false)
  const [modal, setModal] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [isLoadingFuelOrder, setIsLoadingFuelOrder] = useState(false)
  const [isLoadingExpense, setIsLoadingExpense] = useState(false)
  const [isLoaded, setIsLoaded] = useState(false)
  const [expenseModal, setExpenseModal] = useState(false)
  const download = (id) => {
    setIsLoading(true)
    window.open(
      `${getURL().FILE_SERVER}/downloadfile/pdf/shippingorder/${id}?t=${getAccessToken()}`,
      '_blank',
      'toolbar=false,scrollbars=yes,resizable=false',
    )
    setIsLoading(false)
  }

  const downloadExpense = (id, bookingNo, date) => {
    setIsLoadingExpense(true)
    let url
    if (bookingNo) url = `${getURL().FILE_SERVER}/download/pdf/ShippingorderExpense/${id}?bookingNo=${bookingNo}&date=${date}&t=${getAccessToken()}`
    else url = `${getURL().FILE_SERVER}/download/pdf/ShippingorderExpense/${id}?bookingNo=&date=${date}&t=${getAccessToken()}`
    window.open(
      url,
      '_blank',
      'toolbar=false,scrollbars=yes,resizable=false',
    )
    setIsLoadingExpense(false)
  }

  const downloadFillingOrder = () => {
    setIsLoadingFuelOrder(true)
    setIsLoaded(true)
    window.open(
      `${getURL().FILE_SERVER}/downloadfile/pdf/fuelOrder/${ShippingorderInfo.FuelOrder.id}?t=${getAccessToken()}`,
      '_blank',
      'toolbar=false,scrollbars=yes,resizable=false',
    )
    setIsLoadingFuelOrder(false)
  }

  const haveInitial = !_.isUndefined(ShippingorderInfo) && !_.isNull(ShippingorderInfo.FuelOrder.id)
  const pricePerLitre = _.isUndefined(mutationVariables) ? haveInitial ? ShippingorderInfo.FuelOrder.pricePerLitre : undefined : mutationVariables.pricePerLitre
  const totalAmount = _.isUndefined(mutationVariables) ? haveInitial ? ShippingorderInfo.FuelOrder.totalAmount : undefined : mutationVariables.totalAmount

  const onCreate = () => {
    doAction({
      variables: { ...mutationVariables, unit },
    }).then(({ data }) => {
      const resp = data.CreateShippingorder
      if (resp.success) {
        message.success(resp.message)
        history.push({
          pathname: `/shipping-order/edit/${resp.createdShippingorder.id}`,
          state: { accessDriver: true },
        })
      } else message.error(resp.message)
    })
  }

  if (creatingFuel) {
    return (
      <Div />
    )
  }

  return (
    <Div
      position='fixed'
      height='72px'
      bottom='0'
      left='0'
      right='0'
      style={{ background: `${color.primaryColor}33` }}
      display='flex'
      justifyContent='flex-end'
      alignItems='center'
      padding='0 32px 0 0'
    >
      <ChangeJobModal
        jobId={ShippingorderInfo?.Job?.id}
        shippingId={ShippingorderInfo?.id}
        visible={changeJobModal}
        setVisible={setChangeJobModal}
        refetch={refetch}
        onSuccess={() => window.location.reload()}
      />
      {
        !isAddMode && <KonsysButton text='ย้ายสัญญางาน' onClick={() => setChangeJobModal(true)} margin='0 8px' disabled={_.includes([status.CANCELLED], ShippingorderInfo.status)} />
      }
      <KonsysButton text='พิมพ์ค่าใช้จ่าย' icon='fas fa-print' onClick={() => setExpenseModal(true)} margin='0 8px'
        loading={isLoadingExpense}
        disabled={
          isLoadingExpense || isAddMode
        } />
      <KonsysButton text='พิมพ์ใบเบิกน้ำมัน' icon='fas fa-print' onClick={() => downloadFillingOrder()} margin='0 8px'
        loading={isLoadingFuelOrder}
        disabled={
          isAddMode
          || isLoaded
          || (_.includes(['SuperAdmin', 'Admin'], window.role) ? !_.includes([fuelStatus.WAITING, fuelStatus.PRINTED], ShippingorderInfo.FuelOrder.status) : !_.includes([fuelStatus.WAITING], ShippingorderInfo.FuelOrder.status))
          || !_.includes(window.perms, PERMISSION.PRINT_FUEL)
        } />
      <KonsysButton text='พิมพ์ใบสั่งรถบรรทุก' icon='fas fa-print' loading={isLoading} disabled={isLoading || disabledPrint} onClick={() => download(props.match.params.id || ShippingorderInfo.id)} margin='0 8px' />
      {
        !isAddMode && <KonsysButton text='สร้างซ้ำ' icon='fas fa-plus' onClick={() => setModal(true)} margin='0 8px' disabled={!_.includes(window.perms, PERMISSION.CREATE_SHIPPING_ORDER)} />
      }
      {
        !isAddMode && !isViewMode
        && <KonsysButton
          loading={loading}
          disabled={
            loading
            || !_.includes(window.perms, PERMISSION.UPDATE_SHIPPING_ORDER) || (!_.includes([status.ASSIGNED, status.CANCELLED, status.WAITING, status.PICKEDUP, status.DELIVERED, status.EXPIRED], ShippingorderInfo.status))
            || ((_.isUndefined(mutationVariables.assignDate) || mutationVariables.assignDate === 'Invalid date')
              || _.isUndefined(mutationVariables.compensation)
              || (_.isUndefined(mutationVariables.endDestination) || _.isNaN(mutationVariables.endDestination))
              || (_.isUndefined(mutationVariables.shippingNumber) || _.isEmpty(mutationVariables.shippingNumber))
              || (_.isUndefined(mutationVariables.shippingVolume) || _.isEmpty(mutationVariables.shippingVolume))
              || (_.isUndefined(mutationVariables.startDestination) || _.isNaN(mutationVariables.startDestination))
              || _.isUndefined(mutationVariables.weightDifferenceLimit)
            )
          }
          text='บันทึก'
          icon='fas fa-save'
          margin='0 8px'
          inverse
          onClick={() => {
            if (_.isUndefined(mutationVariables.assignDate) && _.isUndefined(ShippingorderInfo.assignDate)) {
              message.error('กรุณากรอกวันที่ครบกำหนด')
            } else {
              doAction({
                variables: {
                  id: parseInt(props.match.params.id || ShippingorderInfo.id, 10),
                  price: parseFloat(pricePerLitre * totalAmount),
                  ...mutationVariables,
                },
              }).then(({ data }) => {
              const resp = data.UpdateShippingorder
              if (resp.success) {
              message.success(resp.message)
              window.location.href = `/shipping-order/view/${props.match.params.id || ShippingorderInfo.id}`
              } else message.error(resp.message)
              })
            }
          }}
        />

      }
      <ExpenseModal
        id={props.match.params.id || ShippingorderInfo.id}
        isLoadingExpense={isLoadingExpense}
        expenseModal={expenseModal}
        setExpenseModal={setExpenseModal}
        downloadExpense={downloadExpense}
      />
      {
        (isViewMode || isAddMode)
        && <KonsysButton
          margin='0 8px'
          loading={loading}
          disabled={
            loading || (isViewMode && (!_.includes(window.perms, PERMISSION.UPDATE_SHIPPING_ORDER) || !_.includes([status.WAITING, status.ASSIGNED, status.EXPIRED, status.CANCELLED, status.DELIVERED], ShippingorderInfo.status) || isLatedMoreThan15days(ShippingorderInfo.status, ShippingorderInfo.assignDate)))
            || (isAddMode
              && (_.isUndefined(mutationVariables.startDestination) || _.isNaN(mutationVariables.startDestination)
                || _.isUndefined(mutationVariables.endDestination) || _.isNaN(mutationVariables.endDestination)
                || _.isUndefined(mutationVariables.shippingVolume) || _.isEmpty(mutationVariables.shippingVolume)
                || _.isUndefined(mutationVariables.shippingNumber) || _.isEmpty(mutationVariables.shippingNumber)
                || _.isUndefined(mutationVariables.compensation)
                || _.isUndefined(mutationVariables.weightDifferenceLimit)
                || _.isUndefined(mutationVariables.containerOption)
                // || _.isUndefined(mutationVariables.assignDate) || mutationVariables.assignDate === 'Invalid date'
              )
            )
          }
          text={isAddMode ? 'สร้างใหม่' : isViewMode && 'แก้ไข'}
          icon={isAddMode ? 'fas fa-plus' : isViewMode && 'fas fa-edit'}
          inverse
          onClick={() => {
            if (isViewMode) history.push(`/shipping-order/edit/${props.match.params.id || ShippingorderInfo.id}`)
            else if (isAddMode && _.isUndefined(mutationVariables.assignDate)) {
              message.error('กรุณากรอกวันที่ครบกำหนด')
            } else if (!isNil(jobInfo.availableOrder) && isAddMode && (jobInfo.availableOrder - jobInfo.shippings.length <= 0)) {
              if (!_.includes(window.perms, PERMISSION.CREATE_SHIPPING_ORDER_OVER_LIMIT)) {
                message.error('ผู้ใช้ไม่สามารถสร้างใบสั่งบรรทุกเกินจำนวนที่แนะนำได้')
              } else {
                Modal.confirm({
                  title: 'ต้องการสร้างใบสั่งบรรทุกเกินจำนวนที่แนะนำใช่หรือไม่',
                  okText: 'สร้าง',
                  cancelText: 'ยกเลิก',
                  onOk() {
                    onCreate()
                  },
                  onCancel() { },
                })
              }
            } else {
              onCreate()
            }
          }}
        />
      }
      <DuplicateModal
        id={parseInt(props.match.params.id || ShippingorderInfo.id, 10)}
        modal={modal}
        setModal={setModal}
        fuelId={!isAddMode && ShippingorderInfo.FuelOrder.id}
        driverId={!isAddMode && ShippingorderInfo.Driver.id}
        availableOrder={jobInfo?.availableOrder}
        shippingsAmount={jobInfo?.shippings?.length}
      />
    </Div>
  )
}

export const CancelModal = ({
  visible, setVisible, refetch, shippingId, fuelOrders,
}) => {
  const [remainingAmount, setRemainingAmount] = useState()
  const [cancel] = useMutation(CANCEL_SHIPPING_ORDER)

  // Clear remainingAmount when modal opens
  useEffect(() => {
    if (visible) {
      setRemainingAmount(undefined)
    }
  }, [visible])

  const doCancel = async () => {
    const resp = await cancel({
      variables: {
        id: shippingId,
        remainingAmount,
      },
    })

    const response = resp.data?.DeleteShippingorder
    if (response?.success) {
      message.success(response?.message)
      refetch()
    } else {
      message.error(response?.message)
    }
    setVisible(false)
  }


  return (
    <Modal
      visible={visible}
      title='ยกเลิกใบสั่งบรรทุก ?'
      okText='ยกเลิก'
      okType='danger'
      cancelText='เก็บไว้'
      okButtonProps={{
        disabled: !_.isEmpty(fuelOrders) && (_.isNil(remainingAmount) || _.isNaN(remainingAmount)),
      }}
      onOk={doCancel}
      onCancel={() => setVisible(false)}
    >
      <div className='space-y-4'>
        <p className='w-full block mb-6!'>เมื่อตกลงแล้วไม่สามารถย้อนกลับได้</p>
        {
          !_.isEmpty(fuelOrders)
          && (
            <InputWithLabelBlock
              isFloat
              decimal={1}
              data={{
                id: 'remainingFuel',
                value: remainingAmount,
                props: {
                  title: { text: 'กรอกน้ำมันคงเหลือ *' },
                  style: {
                    width: '100%',
                  },
                },
              }}
              onChangeHandler={(id, value) => setRemainingAmount(value)}
            />
          )
        }
      </div>
    </Modal>
  )
}

export const ChangeJobModal = ({
  visible, setVisible, refetch, shippingId, jobId, onSuccess,
}) => {
  const [getJobs, { data: jobsData }] = useLazyQuery(JOB_SEARCH)
  const [changeJob, { loading }] = useMutation(MOVE_SHIPPING_ORDER)
  const [job, setJob] = useState()

  const { availableOrder, shippings } = job?.jobInfo || {}

  const doChange = async () => {
    const doChangeJob = () => {
      changeJob({
        variables: {
          shippingOrderId: shippingId,
          jobId: job?.id,
        },
      }).then((resp) => {
        const response = resp.data?.MoveShippingOrder
        if (response?.success) {
          setJob()
          message.success(response?.message)
          refetch()
          setVisible(false)
          // Call onSuccess callback if provided (e.g., to reload page)
          if (onSuccess) {
            onSuccess()
          }
        } else {
          message.error(response?.message)
        }
      })
    }
    if (!isNull(availableOrder) && availableOrder - shippings?.length <= 0) {
      if (_.includes(window.perms, PERMISSION.CREATE_SHIPPING_ORDER_OVER_LIMIT)) {
        Modal.confirm({
          title: 'ต้องการย้ายสัญญางาน ?',
          okText: 'ย้าย',
          cancelText: 'ยกเลิก',
          onOk: () => {
            doChangeJob()
          },
        })
      } else {
        Modal.error({
          title: 'ไม่สามารย้ายสัญญางาน',
          content: 'สัญญางานนี้ไม่สามารถย้ายได้เนื่องจากสัญญางานนี้มีจำนวนใบสั่งบรรทุกเกินจำนวนที่แนะนำ',
        })
      }
    } else {
      doChangeJob()
    }
  }

  return (
    <Modal
      visible={visible}
      destroyOnClose
      title='ย้ายสัญญางาน ?'
      okText='ย้าย'
      cancelText='ยกเลิก'
      okButtonProps={{
        disabled: isNil(job),
        loading,
      }}
      onOk={doChange}
      onCancel={() => {
        setVisible(false)
        setJob()
      }}
    >
      <div className='!space-y-4'>
        <p className='w-full block !mb-0'>เลือกสัญญางาน</p>
        <AutoComplete
          dataSource={(filterLodash(jobsData?.searchJobByVolumnNumber?.lists, v => v.id !== jobId) || []).map(v => v.key)}
          style={{ width: 200 }}
          onSelect={(e) => {
            setJob(_.find((jobsData?.searchJobByVolumnNumber?.lists || []), o => o.key === e))
          }}
          onSearch={(e) => {
            setJob()
            getJobs({
              variables: {
                key: e,
              },
            })
          }}
          placeholder="ใส่เลขที่สัญญางาน"
        />
        <div className='w-full grid grid-cols-3 gap-4'>
          <p>สามารถสร้างได้: <strong>{isNil(availableOrder) ? '-' : availableOrder}</strong></p>
          <p>สร้างแล้ว: <strong>{isNil(availableOrder) ? '-' : shippings?.length}</strong></p>
          <p>เหลือ: <strong>{isNil(availableOrder) ? '-' : availableOrder - shippings?.length}</strong></p>
        </div>
      </div>
    </Modal>
  )
}

export const DuplicateModal = ({
  id, setModal, modal, refetch, fuelId, driverId, availableOrder, shippingsAmount,
}) => {
  const [amount, setamount] = useState()
  const [isSameDriver, setisSameDriver] = useState()
  const [isIncludeFuelOrder, setisIncludeFuelOrder] = useState()
  const [assignDate, setAssignDate] = useState()
  const [expireDate, setExpireDate] = useState()
  const canCreateOverLimit = _.includes(window.perms, PERMISSION.CREATE_SHIPPING_ORDER_OVER_LIMIT)

  const handleOk = (doDuplicate) => {
    const onCreate = () => {
      doDuplicate({
        variables: {
          id,
          total: parseInt(amount, 10),
          isSameDriver,
          isIncludeFuelOrder,
          assignDate,
          expiredDate: isIncludeFuelOrder ? expireDate : undefined,
        },
      }).then((resp) => {
        const response = resp.data.CopyShippingOrder
        if (response.success) {
          message.success(response.message)
          if (!_.isUndefined(refetch)) refetch()
        } else message.error(response.message)
        setModal(false)
      })
    }
    if (isIncludeFuelOrder && _.isUndefined(expireDate)) message.error('โปรดระบุวันหมดอายุใบเบิกน้ำมัน')
    else if (!isNil(availableOrder) && (availableOrder - shippingsAmount < parseInt(amount, 10))) {
      if (canCreateOverLimit) {
        Modal.confirm({
          title: 'ต้องการสร้างใบสั่งบรรทุกเกินจำนวนที่แนะนำใช่หรือไม่',
          okText: 'สร้าง',
          cancelText: 'ยกเลิก',
          onOk() {
            onCreate()
          },
          onCancel() { },
        })
      } else {
        message.error('ไม่สามารถสร้างใบสั่งบรรทุกเกินจำนวนที่แนะนำได้')
      }
    } else {
      onCreate()
    }
  }

  return (
    <Mutation
      mutation={DUPLICATE_SHIPPING_ORDER}
    >{(doDuplicate, res) => (
      <Modal
        title="ต้องการสร้างใบส่งของซ้ำ?"
        visible={modal}
        footer={[
          <Button key="cancel" onClick={() => setModal(false)}>
            ยกเลิก
            </Button>,
          <Button key="submit" type="primary" disabled={_.isNaN(parseInt(amount, 10))} loading={res.loading} onClick={() => {
            if (assignDate === 'Invalid date' || _.isUndefined(assignDate)) message.error('โปรดระบุวันที่ครบกำหนด')
            else handleOk(doDuplicate)
          }}>
            สร้างซ้ำ
            </Button>,
        ]}
        onCancel={() => setModal(false)}
        onOk={() => handleOk(doDuplicate)}
      >
        <Div display='flex' justifyContent='space-between' flexDirection='column'>
          <Div display='flex' flexDirection='row' alignItems='center' margin='8px 0'>
            <P>วันกำหนดการ</P>
            <DatePicker onChange={e => setAssignDate(moment(e).format())} style={{ width: 300 }} />
          </Div>
          <Div display='flex' flexDirection='row' alignItems='flex-end'>
            <InputWithLabel title={{ text: 'สร้างซ้ำจำนวน' }} margin='0 16px 0 0' input={{ onChange: e => setamount(e.target.value) }} />
            <P>ใบ</P>
          </Div>
          <Div margin='16px 0 8px'>
            <Checkbox onChange={e => setisSameDriver(e.target.checked)} disabled={_.isNull(driverId)}>จ่ายงานให้คนเดิม</Checkbox>
          </Div>
          <Div margin='8px 0' display='flex' flexDirection='row' justifyContent='space-between' alignItems='center'>
            <Checkbox onChange={e => setisIncludeFuelOrder(e.target.checked)} disabled={_.isNull(fuelId)}>ใบเบิกน้ำมันเหมือนกัน</Checkbox>
            {
              isIncludeFuelOrder && <Div display='flex' flexDirection='row' alignItems='center'>
                วันหมดอายุ:
                  <DatePicker onChange={e => setExpireDate(e)} style={{ marginLeft: 8 }} />
              </Div>
            }
          </Div>
        </Div>
      </Modal>
    )}</Mutation>
  )
}

export const TextWithLabelAndUnit = ({ data }) => (
  <Div display='flex' alignItems='flex-end'>
    <Div margin='0 16px 0 0'>
      <P margin='0 0 16px 0' style={{ width: 'max-content' }}>{data.text}</P>
      <P margin='0 0 8px 0'>{data.value}</P>
    </Div>
    <P margin='0 0 8px 0'>{data.unit}</P>
  </Div>
)

export const InputWithLabelAndUnit = ({
  data, onChangeHandler, maxLength, isFloat, margin,
}) => (
    <Div display='flex' alignItems='flex-end' margin={margin}>
      <InputWithLabel {...data.props}
        input={{
          type: isFloat ? 'number' : 'text',
          step: isFloat ? '0.1' : undefined,
          min: '0',
          max: maxLength,
          value: data.value,
          // onKeyDown: (e) => {
          //   if (e.keyCode !== 8
          //     && (
          //       (!_.isUndefined(maxLength)
          //         ? (isFloat && (_.includes(e.target.value, '.') || _.includes([110, 190], e.keyCode)))
          //           ? e.target.value.length >= maxLength + 3
          //           : e.target.value.length >= maxLength
          //         : false
          //       )
          //       || (isFloat && !checkFloat(e)))
          //   ) {
          //     e.preventDefault()
          //   }
          // },
          onKeyDown: e => isFloat && checkNotNumber(e) && e.preventDefault(),
          onChange: e => onChangeHandler(data.id, isFloat ? parseFloat(e.target.value) : e.target.value),
          defaultValue: data.defaultValue,
          disabled: data.disabled,
        }}
      />
      <P margin='0 0 8px 0'>{data.unit}</P>
    </Div>
)

export const PickedUpModal = ({
  shippingDetailData, pickedUpModal, setPickedUpModal, refetch, isDataLoaded, shippingDetailLoading,
}) => {
  const [startWeight, setStartWeight] = useState()
  const [fileList, setFileList] = useState([])
  const [truckWithCargoWeight, setTruckWithCargoWeight] = useState()
  const [confirmModal, setConfirmModal] = useState(false)
  const [confirmStartWeight, setConfirmStartWeight] = useState()

  useEffect(() => {
    if (shippingDetailData) {
      setStartWeight(shippingDetailData.ShippingorderInfo.startWeight)
      setFileList(shippingDetailData.ShippingorderInfo.images.map(v => (_.isUndefined(v.originFileObj) ? { url: v.url } : v.originFileObj)))
    }
  }, [shippingDetailData])

  if (!isDataLoaded) return null
  if (shippingDetailLoading && _.isEmpty(shippingDetailData)) {
    return (
      <Modal
        title="บันทึกการขึ้นของ"
        visible={pickedUpModal}
      >
        <Loading center='true'/>
      </Modal>
    )
  }
  const data = shippingDetailData.ShippingorderInfo

  const handleOk = (doRecord) => {
    const variablesChooser = data.Job.dealType === 'PERTRIP'
      ? {}
      : {
        truckWithCargoWeight: parseFloat(truckWithCargoWeight),
        startWeight: parseFloat(startWeight),
      }
    doRecord({
      variables: {
        id: data.id,
        ...variablesChooser,
        images: fileList,
      },
    }).then((resp) => {
      const response = resp.data.DriverPickedUp
      if (response.success) {
        message.success(response.message)
        refetch()
        setPickedUpModal(false)
      } else message.error(response.message)
    })
  }

  const weightDifference = parseFloat(truckWithCargoWeight) - parseFloat(data.Truck.type.maxWeight)

  return (
    <Mutation
      mutation={DRIVER_PICKED_UP}
    >{(doRecord, { loading }) => (
      <Modal
        title="บันทึกการขนส่ง"
        visible={pickedUpModal}
        destroyOnClose={true}
        bodyStyle={{ padding: '16px' }}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setPickedUpModal(false)
              setStartWeight()
              setTruckWithCargoWeight()
              setFileList([])
            }}
            disabled={loading}
          >
            ปิด
          </Button>,
          <Button
            key="submit"
            type="primary"
            disabled={loading || (data.Job.dealType === 'PERWEIGHT'
              && (_.isEmpty(startWeight)))
            || fileList.length <= shippingDetailData.ShippingorderInfo.images
            }
            loading={loading}
            onClick={() => {
              if (data.Job.dealType === 'PERTRIP') {
                handleOk(doRecord)
              } else {
                setConfirmModal(true)
              }
            }}
          >
            บันทึก
          </Button>,
        ]}
        onCancel={() => {
          setPickedUpModal(false)
          setStartWeight()
          setTruckWithCargoWeight()
          setFileList([])
        }}
      >
        <Modal
          title="ยืนยันการบันทึก"
          visible={confirmModal}
          onOk={() => {
            handleOk(doRecord)
            setConfirmModal(false)
          }}
          onCancel={() => {
            setConfirmStartWeight()
            setConfirmModal(false)
          }}
          okButtonProps={{
            disabled: confirmStartWeight !== startWeight,
          }}
        >
          <p className='!mb-0 text-black'>กรอกน้ำหนักสินค้าต้นทางเพื่อยืนยันอีกครั้ง</p>
          <div className='grid w-full grid-cols-3 gap-4 flex items-center my-3'>
            <p className='!mb-0 text-error'>น้ำหนักสินค้าต้นทาง*:</p>
            <div className='flex items-center col-span-2'>
              <Input
                width='200px'
                type='number'
                pattern='[0-9]*'
                inputMode='decimal'
                step={1}
                min={0}
                value={confirmStartWeight || ''}
                onKeyDown={(e) => {
                  if (!checkFloat(e)) {
                    e.preventDefault()
                  }
                }}
                onChange={(e) => {
                  // if (_.isNaN(e.target.value) || (e.target.value >= 0 && e.target.value <= 40000)) {
                  setConfirmStartWeight(e.target.value)
                  // }
                }}
              />
              <p className='!mb-0 font-medium text-charcoal-grey !ml-2'>กิโลกรัม</p>
            </div>
          </div>
          {
            (confirmStartWeight && confirmStartWeight !== startWeight)
            && (
              <div className='flex items-center py-1 px-4 bg-[#D959481A] rounded-md justify-center my-3'>
                <TriangleAlert className='text-error mr-1' />
                <p className='text-error !mb-0'>กรอกน้ำหนักสินค้าต้นทางไม่ตรงกัน กรุณากรอกใหม่</p>
              </div>
            )
          }
        </Modal>
        <div className='grid w-full grid-cols-2 gap-4'>
          <div className='flex items-center'>
            <p className='!mb-0 font-bold text-black mr-1'>เล่มที่:</p>
            <p className='!mb-0 font-bold text-charcoal-grey'>{data.shippingVolume}</p>
          </div>
          <div className='flex items-center'>
            <p className='!mb-0 font-bold text-black mr-1'>เลขที่:</p>
            <p className='!mb-0 font-bold text-charcoal-grey'>{data.shippingNumber}</p>
          </div>
        </div>
        <hr className='my-5 text-pale-grey' />
        <div className='grid w-full grid-cols-3 gap-4'>
          <p className='!mb-0 text-[##000000A6]'>เบี้ยเลี้ยง:</p>
          <p className='!mb-0 font-medium text-charcoal-grey col-span-2'>{numeral(parseFloat(data.compensation)).format('(0,0.00)')} บาท</p>
        </div>
        <hr className='my-5 text-pale-grey' />
        {
          data.Job.dealType === 'PERWEIGHT'
          && (
            <>
              <div className='grid w-full grid-cols-3 gap-4'>
                <p className='!mb-0 text-[##000000A6]'>น้ำหนักตามเกณฑ์:</p>
                <div className='col-span-2 flex items-center gap-2'>
                  <p className='!mb-0 font-medium text-charcoal-grey '>{numeral(parseFloat(data.Truck.type.maxWeight)).format('(0,0.00)')} กิโลกรัม</p>
                  <p className={`!mb-0 font-bold ${weightDifference !== 0 ? 'text-error' : 'text-charcoal-grey'}`}>
                    {
                      isNaN(weightDifference)
                      ? '-'
                      : weightDifference === 0
                        ? '(พอดี)'
                        : weightDifference > 0
                          ? `(เกิน ${numeral(Math.abs(weightDifference)).format('0,0.00')} กิโลกรัม)`
                          : `(ขาด ${numeral(Math.abs(weightDifference)).format('0,0.00')} กิโลกรัม)`
                    }
                  </p>
                </div>
              </div>
              <div className='grid w-full grid-cols-3 gap-4 flex items-center my-3'>
                <p className='!mb-0 text-error'>น้ำหนักรถรวมสินค้าต้นทาง*:</p>
                <div className='flex items-center col-span-2'>
                  <Input
                    width='200px'
                    type='number'
                    pattern='[0-9]*'
                    inputMode='decimal'
                    step={1}
                    min={0}
                    value={truckWithCargoWeight || ''}
                    onKeyDown={(e) => {
                      if (!checkFloat(e)) {
                        e.preventDefault()
                      }
                    }}
                    onChange={e => setTruckWithCargoWeight(e.target.value)}
                  />
                  <p className='!mb-0 font-medium text-charcoal-grey !ml-2'>กิโลกรัม</p>
                </div>
              </div>
              <div className='grid w-full grid-cols-3 gap-4 flex items-center my-3'>
                <p className='!mb-0 text-[##000000A6]'>น้ำหนักสินค้าต้นทาง*:</p>
                <div className='flex items-center col-span-2'>
                  <Input
                    width='200px'
                    type='number'
                    pattern='[0-9]*'
                    inputMode='decimal'
                    step={1}
                    min={0}
                    value={startWeight}
                    onKeyDown={(e) => {
                      if (!checkFloat(e)) {
                        e.preventDefault()
                      }
                    }}
                    onChange={(e) => {
                      // if (_.isNaN(e.target.value) || (e.target.value >= 0 && e.target.value <= 40000)) {
                      setStartWeight(e.target.value)
                    }}
                  />
                  <p className='!mb-0 font-medium text-charcoal-grey !ml-2'>กิโลกรัม</p>
                </div>
              </div>
              {
                weightDifference > 0
                && (
                  <div className='flex items-center py-1 px-4 bg-[#D9AB481A] rounded-md justify-center my-3'>
                    <TriangleAlert className='text-warning mr-1' />
                    <p className='text-warning !mb-0'>กรอกน้ำหนักรถรวมสินค้าต้นทางเกินเกณฑ์ที่ระบบแนะนำ</p>
                  </div>
                )
              }
              {/* <div className='grid w-full grid-cols-3 gap-4 mb-4'>
                <p className='!mb-0 text-[##000000A6]'>น้ำหนักขาดเกิน:</p>
                <p className={`!mb-0 font-medium ${weightDifference !== 0 ? 'text-error' : 'text-charcoal-grey'} col-span-2`}>
                  {
                    isNaN(weightDifference)
                    ? '-'
                    : weightDifference === 0
                      ? 'พอดี'
                      : weightDifference > 0
                        ? `เกิน ${numeral(Math.abs(weightDifference)).format('0,0.00')} กิโลกรัม`
                        : `ขาด ${numeral(Math.abs(weightDifference)).format('0,0.00')} กิโลกรัม`
                  }
                </p>
              </div> */}
            </>
          )
        }
        <Row align='flex-start' type='flex'>
          <Upload
            className='driver-upload'
            onChange={e => setFileList(e.fileList.map(v => (_.isUndefined(v.originFileObj) ? { url: v.url } : v.originFileObj)))}
            showUploadList={{
              showRemoveIcon: true,
            }}
            customRequest={() => null}
            processData={false}
            beforeUpload={() => false}
            multiple={true}
            defaultFileList={data.images.map(v => ({
              name: v.filename,
              url: v.url,
              uid: v.url,
            }))}
            listType='picture-card'
            accept='image/*, .heic, .pdf'
          >
            <Icon type="upload" />
            <br />อัพโหลดรูป
          </Upload>
        </Row>
      </Modal>
    )}
    </Mutation>
  )
}

export const ScanModal = ({
  shippingDetailData, visible, setVisible,
}) => {
  const { data: image, loading: qrcodeLoading } = useQuery(GET_SHIPPING_ORDER_QR_CODE, { variables: { id: shippingDetailData?.id }, skip: !visible })

  return (
    <Mutation
      mutation={DRIVER_PICKED_UP}
    >{(doRecord, { loading }) => (
      <Modal
        title="แสกน QR Code ใบสั่งบรรทุก"
        visible={visible}
        destroyOnClose={true}
        onCancel={() => setVisible(false)}
      >
        <Div display='flex' flexDirection='column' width='100%' alignItems='center'>
          <Row style={{ margin: '4px 0', width: '100%' }} type='flex' justify='space-between' gutter={16} align='middle'>
            <Col span={6}>
              <img src={pdr} style={{ width: '100%' }}/>
            </Col>
            <Col span={18}>
              <P bold>ผู้ขนส่ง</P>
              <SmallText>{COMPANY_NAME[shippingDetailData?.Job?.companyType]}</SmallText>
            </Col>
          </Row>
          <Row style={{ margin: '4px 0', width: '100%' }} type='flex' justify='space-between' gutter={16} align='middle'>
            <Col span={6}>
              <img src={logoSelector(shippingDetailData.Customer.id)} style={{ width: '100%' }}/>
            </Col>
            <Col span={18}>
              <P bold>ผู้ว่าจ้าง</P>
              <SmallText>{shippingDetailData?.Customer?.companyName}</SmallText>
            </Col>
          </Row>
          {
            qrcodeLoading && visible
            ? <LoadingPage />
            : <img src={image?.getShippingorderQRCode?.data?.image} />
          }
          <Div width='100%' alignItems='center' display='flex' margin='8px 0'>
            <KSIcon style={{ width: 25 }} icon='far fa-truck-moving' color={theme.color.coolGray} fontSize='20px' margin='0 16px 0 0'/>
            <SmallText color={theme.color.coolGray}>{shippingDetailData?.Truck?.plateNumber || '-'}</SmallText>
          </Div>
          <Div width='100%' alignItems='center' display='flex' margin='8px 0'>
            <KSIcon style={{ width: 25 }} icon='far fa-user' color={theme.color.coolGray} fontSize='20px' margin='0 16px 0 0'/>
            <SmallText color={theme.color.coolGray}>{shippingDetailData?.Driver?.fullname || '-'}</SmallText>
          </Div>
          <Div width='100%' alignItems='center' display='flex' margin='8px 0'>
            <KSIcon style={{ width: 25 }} icon='far fa-truck-loading' color={theme.color.coolGray} fontSize='20px' margin='0 16px 0 0'/>
            <SmallText color={theme.color.coolGray}>{shippingDetailData?.startDestinationLocation?.name || '-'}</SmallText>
          </Div>
          <Div width='100%' alignItems='center' display='flex' margin='8px 0'>
            <KSIcon style={{ width: 25 }} icon='far fa-map-marker-alt' color={theme.color.coolGray} fontSize='20px' margin='0 16px 0 0'/>
            <SmallText color={theme.color.coolGray}>{shippingDetailData?.endDestinationLocation?.name || '-'}</SmallText>
          </Div>
        </Div>
      </Modal>
    )}
    </Mutation>
  )
}

export const DeliveryModal = ({
  shippingDetailData, deliveryModal, setDeliveryModal, refetch, isDataLoaded, shippingDetailLoading,
}) => {
  const [startWeight, setStartWeight] = useState()
  const [endWeight, setEndWeight] = useState()
  const [fileList, setFileList] = useState([])
  const [confirmModal, setConfirmModal] = useState(false)
  const [confirmEndWeight, setConfirmEndWeight] = useState()

  useEffect(() => {
    if (shippingDetailData) {
      setStartWeight(shippingDetailData.ShippingorderInfo.startWeight)
      setEndWeight(shippingDetailData.ShippingorderInfo.endWeight)
      setFileList(shippingDetailData.ShippingorderInfo.images.map(v => (_.isUndefined(v.originFileObj) ? { url: v.url } : v.originFileObj)))
    }
  }, [shippingDetailData])

  if (!isDataLoaded) return null
  if (shippingDetailLoading && _.isEmpty(shippingDetailData)) {
    return (
      <Modal
        title="บันทึกการขนส่ง"
        visible={deliveryModal}
      >
        <Loading center='true'/>
      </Modal>
    )
  }
  const data = shippingDetailData.ShippingorderInfo

  const handleOk = (doRecord) => {
    const variablesChooser = data.Job.dealType === 'PERTRIP'
      ? {}
      : {
        endWeight: parseFloat(endWeight),
      }
    doRecord({
      variables: {
        id: data.id,
        ...variablesChooser,
        images: fileList,
      },
    }).then((resp) => {
      const response = resp.data.DriverDelivered
      if (response.success) {
        message.success(response.message)
        refetch()
        setDeliveryModal(false)
      } else message.error(response.message)
    })
  }

  const weightDifferenceStart = parseFloat(data.truckWithCargoWeight) - parseFloat(data.Truck.type.maxWeight)
  const weightDifferenceEnd = parseFloat(endWeight) - parseFloat(data.startWeight)

  return (
    <Mutation
      mutation={DRIVER_DELIVERED}
    >{(doRecord, { loading }) => (
      <Modal
        title="บันทึกการขนส่ง"
        visible={deliveryModal}
        destroyOnClose={true}
        bodyStyle={{ padding: '16px' }}
        footer={[
          <Button
            key="cancel"
            onClick={() => {
              setDeliveryModal(false)
              setEndWeight()
              setFileList([])
            }}
            disabled={loading}
          >
            ปิด
          </Button>,
          <Button
            key="submit"
            type="primary"
            disabled={loading || fileList?.length <= shippingDetailData?.ShippingorderInfo?.images?.length
              || (data.Job.dealType === 'PERWEIGHT'
                && (_.isUndefined(startWeight) || _.isEmpty(endWeight)))
                // && (_.isUndefined(startWeight) || _.isEmpty(endWeight) || parseFloat(endWeight) < 10000))
            }
            loading={loading}
            onClick={() => {
              if (data.Job.dealType === 'PERTRIP') {
                handleOk(doRecord)
              } else {
                setConfirmModal(true)
              }
            }}
          >
            บันทึก
          </Button>,
        ]}
        onCancel={() => {
          setDeliveryModal(false)
          setEndWeight()
          setFileList([])
        }}
      >
        <Modal
          title="ยืนยันบันทึกการขนส่ง"
          visible={confirmModal}
          onCancel={() => {
            setConfirmModal(false)
            setConfirmEndWeight()
          }}
          onOk={() => {
            handleOk(doRecord)
            setConfirmModal(false)
          }}
          okButtonProps={{
            disabled: confirmEndWeight !== endWeight,
          }}
        >
          <p className='!mb-0 text-black'>กรอกน้ำหนักสินค้าปลายทางเพื่อยืนยันอีกครั้ง</p>
          <div className='grid w-full grid-cols-3 gap-4 flex items-center my-3'>
            <p className='!mb-0 text-error'>น้ำหนักสินค้าปลายทาง*:</p>
            <div className='flex items-center col-span-2'>
              <Input
                width='200px'
                type='number'
                pattern='[0-9]*'
                inputMode='decimal'
                step={1}
                min={0}
                value={confirmEndWeight || ''}
                onKeyDown={(e) => {
                  if (!checkFloat(e)) {
                    e.preventDefault()
                  }
                }}
                onChange={(e) => {
                  // if (_.isNaN(e.target.value) || (e.target.value >= 0 && e.target.value <= 40000)) {
                  setConfirmEndWeight(e.target.value)
                  // }
                }}
              />
              <p className='!mb-0 font-medium text-charcoal-grey !ml-2'>กิโลกรัม</p>
            </div>
          </div>
          {
            (confirmEndWeight && confirmEndWeight !== endWeight)
            && (
              <div className='flex items-center py-1 px-4 bg-[#D959481A] rounded-md justify-center my-3'>
                <TriangleAlert className='text-error mr-1' />
                <p className='text-error !mb-0'>กรอกน้ำหนักสินค้าปลายทางไม่ตรงกัน กรุณากรอกใหม่</p>
              </div>
            )
          }
        </Modal>
        <div className='grid w-full grid-cols-2 gap-4'>
          <div className='flex items-center'>
            <p className='!mb-0 font-bold text-black mr-1'>เล่มที่:</p>
            <p className='!mb-0 font-bold text-charcoal-grey'>{data.shippingVolume}</p>
          </div>
          <div className='flex items-center'>
            <p className='!mb-0 font-bold text-black mr-1'>เลขที่:</p>
            <p className='!mb-0 font-bold text-charcoal-grey'>{data.shippingNumber}</p>
          </div>
        </div>
        <hr className='my-5 text-pale-grey' />
        <div className='grid w-full grid-cols-3 gap-4'>
          <p className='!mb-0 text-[##000000A6]'>เบี้ยเลี้ยง:</p>
          <p className='!mb-0 font-medium text-charcoal-grey col-span-2'>{numeral(parseFloat(data.compensation)).format('(0,0.00)')} บาท</p>
        </div>
        <hr className='my-5 text-pale-grey' />
        {
          data.Job.dealType === 'PERWEIGHT'
          && (
            <>
              <div className='grid w-full grid-cols-3 gap-4'>
                <p className='!mb-0 text-[##000000A6]'>น้ำหนักตามเกณฑ์:</p>
                <div className='col-span-2 flex items-center gap-2'>
                <p className='!mb-0 font-medium text-charcoal-grey'>{numeral(parseFloat(data.Truck.type.maxWeight)).format('(0,0.00)')} กิโลกรัม</p>
                  <p className={`!mb-0 font-bold ${weightDifferenceStart !== 0 ? 'text-error' : 'text-charcoal-grey'}`}>
                    {
                      isNaN(weightDifferenceStart)
                      ? '-'
                      : weightDifferenceStart === 0
                        ? '(พอดี)'
                        : weightDifferenceStart > 0
                          ? `(เกิน ${numeral(Math.abs(weightDifferenceStart)).format('0,0.00')} กิโลกรัม)`
                          : `(ขาด ${numeral(Math.abs(weightDifferenceStart)).format('0,0.00')} กิโลกรัม)`
                      }
                    </p>
                  </div>
              </div>
              <div className='grid w-full grid-cols-3 gap-4 flex items-center my-3'>
                <p className='!mb-0 text-[##000000A6]'>น้ำหนักสินค้าต้นทาง*:</p>
                <p className='!mb-0 font-medium text-charcoal-grey col-span-2'>{numeral(parseFloat(data.startWeight)).format('(0,0.00)')} กิโลกรัม</p>
              </div>
              {/* <div className='grid w-full grid-cols-3 gap-4 mb-4'>
                <p className='!mb-0 text-[##000000A6]'>น้ำหนักขาดเกิน:</p>
                <p className={`!mb-0 font-medium ${weightDifferenceStart !== 0 ? 'text-error' : 'text-charcoal-grey'} col-span-2`}>
                  {
                    isNaN(weightDifferenceStart)
                    ? '-'
                    : weightDifferenceStart === 0
                    ? 'พอดี'
                    : weightDifferenceStart > 0
                    ? `เกิน ${numeral(Math.abs(weightDifferenceStart)).format('0,0.00')} กิโลกรัม`
                    : `ขาด ${numeral(Math.abs(weightDifferenceStart)).format('0,0.00')} กิโลกรัม`
                  }
                </p>
              </div> */}
              <hr className='my-5 text-pale-grey' />
              <div className='grid w-full grid-cols-3 gap-4 flex items-center my-3'>
                <p className='!mb-0 text-error'>น้ำหนักสินค้าปลายทาง*:</p>
                <div className='flex items-center col-span-2'>
                  <Input
                    width='200px'
                    type='number'
                    pattern='[0-9]*'
                    inputMode='decimal'
                    step={1}
                    min={0}
                    value={endWeight}
                    onKeyDown={(e) => {
                      if (!checkFloat(e)) {
                        e.preventDefault()
                      }
                    }}
                    onChange={(e) => {
                      // if (_.isNaN(e.target.value) || (e.target.value >= 0 && e.target.value <= 40000)) {
                      setEndWeight(e.target.value)
                    }}
                  />
                  <p className='!mb-0 font-medium text-charcoal-grey !ml-2'>กิโลกรัม</p>
                </div>
              </div>
              {/* {
                weightDifferenceEnd > 0
                && (
                  <div className='flex items-center py-1 px-4 bg-[#D9AB481A] rounded-md justify-center my-3'>
                    <TriangleAlert className='text-warning mr-1' />
                    <p className='!mb-0 text-warning !mb-0'>กรอกน้ำหนักสินค้าปลายทางเกินเกณฑ์ที่ระบบแนะนำ</p>
                  </div>
                )
              } */}
              <div className='grid w-full grid-cols-3 gap-4 mb-4'>
                <p className='!mb-0 text-[##000000A6]'>น้ำหนักขาดเกิน:</p>
                <p className={`!mb-0 font-bold ${weightDifferenceEnd !== 0 ? 'text-error' : 'text-charcoal-grey'} col-span-2`}>
                  {
                    isNaN(weightDifferenceEnd)
                    ? '-'
                    : weightDifferenceEnd === 0
                    ? '(พอดี)'
                    : weightDifferenceEnd > 0
                    ? `(เกิน ${numeral(Math.abs(weightDifferenceEnd)).format('0,0.00')} กิโลกรัม)`
                    : `(ขาด ${numeral(Math.abs(weightDifferenceEnd)).format('0,0.00')} กิโลกรัม)`
                  }
                </p>
              </div>
            </>
          )
        }
        <Upload
          className='driver-upload'
          onChange={e => setFileList(e.fileList.map(v => (_.isUndefined(v.originFileObj) ? { url: v.url } : v.originFileObj)))}
          showUploadList={{
            showRemoveIcon: true,
          }}
          customRequest={() => null}
          processData={false}
          beforeUpload={() => false}
          multiple={true}
          defaultFileList={data.images.map(v => ({
            name: v.filename,
            url: v.url,
            uid: v.url,
          }))}
          listType='picture-card'
          accept='image/*, .heic, .pdf'
        >
          <Icon type="upload" />
          <br />อัพโหลดรูป *
        </Upload>
      </Modal>
    )}
    </Mutation>
  )
}

export const InputWithLabelAndUnitOneRow = ({
  data, onChangeHandler, maxLength, isFloat, margin,
}) => (
    <Div display='flex' alignItems='center' margin={margin}>
      <P>{data.props.title.text}</P>
      <Input {...data.props}
        type={isFloat ? 'number' : 'text'}
        step={isFloat ? '0.1' : undefined}
        min='0'
        max={maxLength}
        value={data.value}
        onKeyDown={e => isFloat && checkNotNumber(e) && e.preventDefault()}
        onChange={e => onChangeHandler(data.id, isFloat ? parseFloat(e.target.value) : e.target.value)}
        defaultValue={data.defaultValue}
        disabled={data.disabled}
      />
      <P>{data.unit}</P>
    </Div>
)

export const FloatInput = ({
  data, onChangeHandler, maxLength, isFloat,
}) => (
    <Input {...data.props}
      type={isFloat ? 'number' : 'text'}
      step={isFloat ? '0.1' : undefined}
      min='0'
      max={maxLength}
      value={data.value}
      onKeyDown={e => isFloat && checkNotNumber(e) && e.preventDefault()}
      onChange={e => onChangeHandler(data.id, isFloat ? parseFloat(e.target.value) : e.target.value)}
      defaultValue={data.defaultValue}
      disabled={data.disabled}
      width='100%'
    />
)

export const InputWithLabelBlock = ({
  data, onChangeHandler, maxLength, isFloat, margin, decimal,
}) => {
  const handleKeyDown = (e) => {
    if (!isFloat) return

    // Block invalid characters
    if (checkNotNumber(e)) {
      e.preventDefault()
      return
    }

     // If decimal prop is provided, apply custom decimal validation
     if (decimal !== undefined) {
       const currentValue = e.target.value
       const { key } = e

       // Allow control keys (backspace, delete, arrows, etc.)
       if (e.keyCode >= 8 && e.keyCode <= 46) return

       // Handle leading zeros - only block if trying to add 0 after existing 0
       if (key === '0' && currentValue === '0') {
         e.preventDefault()
         return
       }

       // Handle decimal point
       if (key === '.' || key === ',') {
         // If already has decimal point, block
         if (currentValue.includes('.')) {
           e.preventDefault()
           return
         }
         return
       }

       // Handle digits after decimal point - check if adding this digit would exceed limit
       if (currentValue.includes('.')) {
         const decimalIndex = currentValue.indexOf('.')
         const digitsAfterDecimal = currentValue.length - decimalIndex - 1

         // If we already have the maximum allowed decimal places, block any new digits
         if (digitsAfterDecimal >= decimal) {
           e.preventDefault()
         }
       }
     }
  }

  return (
    <Div display='flex' flex-grow alignItems='flex-end'>
      <InputWithLabel {...data.props}
        margin={margin || '0'}
        input={{
          type: isFloat ? 'number' : 'text',
          step: isFloat ? '0.1' : undefined,
          min: '0',
          max: maxLength,
          value: data.value,
          onKeyDown: handleKeyDown,
          onChange: e => onChangeHandler(data.id, isFloat ? parseFloat(e.target.value) : e.target.value),
          defaultValue: data.defaultValue,
          disabled: data.disabled,
        }}
      />
    </Div>
  )
}

export const InputWithLabelInt = ({
  data, onChangeHandler, maxLength, isInt, margin,
}) => (
    <Div display='flex' alignItems='flex-end'>
      <InputWithLabel {...data.props}
        margin={margin || '0'}
        input={{
          type: isInt ? 'number' : 'text',
          step: isInt ? '1' : undefined,
          min: '0',
          max: maxLength,
          value: data.value,
          onKeyDown: e => isInt && !checkInt(e) && e.preventDefault(),
          onChange: e => onChangeHandler(data.id, isInt ? parseFloat(e.target.value) : e.target.value),
          defaultValue: data.defaultValue,
          disabled: data.disabled,
        }}
      />
    </Div>
)

export const DatePickerWithLabel = ({ data, onChangeHandler, disabledDate }) => (
  <Div display='flex' flexDirection='column' margin='0'>
    <P margin='0 0 16px'>{data.text}</P>
    <DatePicker
      disabledDate={disabledDate}
      value={moment(data.value).isValid() && moment(data.value)}
      disabled={data.disabled}
      defaultValue={moment(data.defaultValue).isValid() && moment(data.defaultValue)}
      onChange={e => onChangeHandler(data.id, moment(e).format('YYYY-MM-DD'))}
    />
  </Div>
)

export const TimePickerWithLabel = ({ data, onChangeHandler }) => (
  <Div display='flex' flexDirection='column' margin='0'>
    <P margin='0 0 16px'>{data.text}</P>
    <TimePicker
      value={moment(data.value, 'HH:mm').isValid() && moment(data.value, 'HH:mm')}
      disabled={data.disabled}
      style={{ width: '100%' }}
      defaultValue={moment(data.defaultValue, 'HH:mm').isValid() && moment(data.defaultValue, 'HH:mm')}
      format='HH:mm'
      onChange={e => onChangeHandler(data.id, moment(e).format('HH:mm'))}
    />
  </Div>
)

export const DropdownWithLabel = ({ data, onChangeHandler }) => (
  <Div display='flex' flexDirection='column' margin='0'>
    <P margin='0 0 16px'>{data.text}</P>
    <Select
      value={mappingValueToText(data.value)}
      disabled={data.disabled}
      defaultValue={mappingValueToText(data.defaultValue)}
      placeholder={data.placeholder}
      showSearch
      optionFilterProp="children"
      onChange={e => onChangeHandler(data.id, e)}
      style={{ width: '100%' }}
    >
      {
        unitVar.map(v => <Select.Option key={v.value} value={v.value} disabled={v.disabled}>{v.text}</Select.Option>)
      }
    </Select>
  </Div>
)

const ExpenseModal = ({
  id, isLoadingExpense, expenseModal, setExpenseModal, downloadExpense,
}) => {
  const [bookingNo, setBookingNo] = useState()
  const [date, setDate] = useState(moment().format('YYYY-MM-DD'))
  return (
    <Modal
      title="พิมพ์ค่าใช้จ่าย"
      visible={expenseModal}
      destroyOnClose={true}
      onCancel={() => {
        setExpenseModal(false)
        setBookingNo()
        setDate(moment().format('YYYY-MM-DD'))
      }}
      onOk={() => {
        downloadExpense(id, bookingNo, date)
        setBookingNo()
        setDate(moment().format('YYYY-MM-DD'))
        setExpenseModal(false)
      }}
      okButtonProps={{
        loading: isLoadingExpense,
      }}
      cancelButtonProps={{
        disabled: isLoadingExpense,
      }}
    >
      <Div display='flex' flexDirection='row' alignItems='center' margin='0 0 16px'>
        <InputWithLabel
          title={{ text: 'หมายเลข Booking No.' }}
          margin='0 16px 0 0'
          input={{ onChange: e => setBookingNo(e.target.value), value: bookingNo }} />
      </Div>
      <P margin='8px 0 16px 0'>วันที่จ่าย</P>
      <DatePicker
        format='YYYY-MM-DD'
        onChange={(e) => {
          setDate(moment(e).format('YYYY-MM-DD'))
        }}
      />
    </Modal>
  )
}
